import Store from '@/store/computed/storeHelpers'
import Api from '@/services/api'
export default {
  methods: {
    getDrivers() {
      this.loadingDrivers = true
      var urlString = 'drivers'
      if (this.includeInactive) urlString += '/includeInactive'
      return Api.get(urlString)
        .then(result => {
          this.drivers = result.data.result
          this.loadingDrivers = false
          return result.data.result
        })
        .catch(err => {
          this.loadingDrivers = false
          this.snackError()
          console.log(err)
        })
    }
  },
  computed: {
    loadingDrivers: Store.getSet({ store: 'drivers', prop: 'loadingDrivers' }),
    drivers: Store.getSet({ store: 'drivers', prop: 'drivers' })
  },
  mounted() {
    if (!this.drivers.length && this.$route.name !== 'audit') {
      this.getDrivers()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.drivers = []
  }
}
